module.exports = __webpack_public_path__ + "img/add_circle_outline-white-18dp.e186591a.svg";